import { render } from "./SickLeaveInfo.vue?vue&type=template&id=159abf6b"
import script from "./SickLeaveInfo.vue?vue&type=script&lang=js"
export * from "./SickLeaveInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__